import { render, staticRenderFns } from "./AdditionalPDFOptions.vue?vue&type=template&id=ca2d25e8&scoped=true"
import script from "./AdditionalPDFOptions.vue?vue&type=script&lang=ts"
export * from "./AdditionalPDFOptions.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalPDFOptions.vue?vue&type=style&index=0&id=ca2d25e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2d25e8",
  null
  
)

export default component.exports